 window.setGridHeight = (selector) => {
  this.heightArray = [];
  this.offsetArrayArray = [];
  this.sectionArray = [];


  document.querySelectorAll(selector).forEach((grid, i) => {
      var tmp = { 'index': i, 'offsetheight': grid.closest(`[data-equal]`).offsetTop };
      this.offsetArrayArray.push(tmp)
  });

  this.diffrentsHeights = []
  this.offsetArrayArray.forEach(function(e) {
      if (this.diffrentsHeights.includes(e.offsetheight) == false) {
          this.diffrentsHeights.push(e.offsetheight)
      }
  });

  this.diffrentsHeights.forEach(function(e) {
      var data = [];
      for (var i = 0; i < this.offsetArrayArray.length; i++) {
          if (this.offsetArrayArray[i].offsetheight == e) {
              data.push(this.offsetArrayArray[i]);
          }
      }
      var getAllHeightArray = [];
      data.forEach(function(ele) {
          document.querySelectorAll(selector)[ele.index].removeAttribute('style');
          getAllHeightArray.push(document.querySelectorAll(selector)[ele.index].offsetHeight);
      })

      var getMaxHeight = Math.max.apply(Math, getAllHeightArray);
      data.forEach(function(ele) {
          document.querySelectorAll(selector)[ele.index].style.minHeight = getMaxHeight + 'px';
      });
  })
}

window.setGridHeight('.icon_with_text_box_layout .column_content_wrap .icon-column__text .title');
window.setGridHeight('.icon_with_text_box_layout .column_content_wrap .icon-column__text p');

window.addEventListener('load',function (params) {
  console.log('page Loaded');
})


if (document.querySelector('.js--price-on-request-button')) {
  document.querySelector('.js--price-on-request-button').addEventListener('click', function() {
      $.fancybox.open({
          src: '[data-price-on-request-form]',
          type: 'inline',
          opts: {
              baseClass: 'popup-modal',
              hash: false,
              infobar: false,
              toolbar: false,
              smallBtn: false,
              touch: {
                  vertical: false,
                  momentum: false
              },
              beforeShow: () => {
                  // Remove previous slides (fix for theme editor)
                  $('.popup-modal .fancybox-slide').empty();
              },
              afterShow: () => {
                  // After content is loaded, attach event listener for custom close icon
                  $(document).on('touchstart click', '.popup__close', () => {
                      $.fancybox.close($('[data-popup]'));
                  });
              },
              beforeClose: () => {
                  // Prevent duplicate triggers for close icon click
                  $('.popup__close').off();
              }
          }
      });
  })
  if (window.location.search == "?contact_posted=true") {
      document.querySelector('.js--price-on-request-button').click();
  }
}

/* 
***************
Scroll to add sticky class for Product page
***************
*/

if (document.body.classList.contains('product-scrolling-template')) {
  window.onscroll = function() {
      let cartButtonOffsetTop = document.querySelector('.shopify-section.product-template').offsetHeight,
          currentPageYscroll = window.pageYOffset;
      if (currentPageYscroll >= cartButtonOffsetTop) {
          document.body.classList.add('show-sticky-popup');
      } else {
          document.body.classList.remove('show-sticky-popup');
      }
  }
}

/* 
***************
Text Engrave Input Event 
***************
*/
if(document.querySelector("#engraving_text_shown")){
  document.querySelector("#engraving_text_shown").addEventListener("input", function(e) {
    document.querySelector("#engraving_text").value = e.target.value;
  });
}


/* 
***************
Language Switcher Events
***************
*/

let languageSwitchersWrapper = document.querySelector(".language_item");
if (languageSwitchersWrapper) {
  let storedLangInterval = setInterval(function() {
      console.log(window.Weglot.getStoredLang);
      if (window.Weglot.getStoredLang != undefined) {
          clearInterval(storedLangInterval);
          let tempLang = window.Weglot.getStoredLang();
          if(tempLang == undefined) tempLang = "de";
          document.querySelectorAll(".js-language-switcher").forEach((languageSwitcher) => {
              languageSwitcher.classList.remove("active");
          });
          document.querySelector(`.js-language-switcher[data-custom-language='${tempLang}']`).classList.add("active");
      }
  }, 100);
}

window.bindLanguageSwitcherEvents = function() {
  let languageSwitchersWrapper = document.querySelector(".language_item");
  if (languageSwitchersWrapper) {
      languageSwitchersWrapper.querySelectorAll(".js-language-switcher").forEach(function(languageSwitcher) {
          languageSwitcher.classList.add("evt-binded");
          languageSwitcher.addEventListener("click", _handleLanguageSwitch.bind(this), true);
      });
  }
}
window.bindLanguageSwitcherEvents();


function _handleLanguageSwitch(e) {
  let selectedLanguage = e.currentTarget.getAttribute("data-custom-language");
  if (window.Weglot.getStoredLang() == selectedLanguage) {
      return;
  }
  window.Weglot.switchTo(selectedLanguage);
  document.querySelectorAll(".js-language-switcher").forEach((languageSwitcher) => {
      languageSwitcher.classList.remove("active");
  });
  let languageSwitchersWrapper = document.querySelector(".language_item");
  languageSwitchersWrapper.querySelectorAll(".js-language-switcher").forEach(function(languageSwitcher) {
      languageSwitcher.classList.remove("evt-binded");
      languageSwitcher.removeEventListener("click", _handleLanguageSwitch.bind(this), true);
  });
  setTimeout(function() {
      window.bindLanguageSwitcherEvents();
      document.querySelector(`.js-language-switcher[data-custom-language='${window.Weglot.getStoredLang()}']`).classList.add("active");
  }, 250);
}